import React, { Component } from 'react';
import { Form, Input, InputNumber, Radio, Checkbox} from 'antd';
import { FormattedMessage, injectIntl} from 'react-intl';
import ReportDescription from './ReportDescription'
import PrintersSelectTable from './PrintersSelectTable'
import UsersSelectTable from './UsersSelectTable'
import UserGroupsSelectTable from './UserGroupsSelectTable'
import {getReportParam} from '../utils/EmailReportsHelper'
import {REPORT_URL} from '../utils/constants'

const layout = {
    labelCol: {
        offset: 0,
        span: 3,
    },
/*    
    wrapperCol: {       
        offset: 0,
        span: 6,
    },
*/    
  };
  
const report_type_name = "Report.DocumentPrinted";
const printer_id_name = "printer_id";
const user_id_name = "user_id";
const group_id_name = "group_id";
const docname_name = "docname";
const minpages_name = "minpages";
const maxpages_name = "maxpages";
const color_name = "color";
const max_count_name = "max_count";
const report_url = "/job";

class DocumentPrintedStep2 extends Component {

    constructor(props) {
        super(props);

        this.printer_id = this.getPrinterId();
        if (this.printer_id !== undefined)
        {
            this.savePrinterId(this.printer_id);
        }

        this.user_id = this.getUserId();
        if (this.user_id !== undefined)
        {
            this.saveUserId(this.user_id);
        }

        this.group_id = this.getGroupId();
        if (this.group_id !== undefined)
        {
            this.saveGroupId(this.group_id);
        }

        this.docname = this.getDocName();
        if (this.docname !== undefined)
        {
            this.saveDocName(this.docname);
        }

        this.minpages = this.getMinPages();
        if (this.minpages !== undefined)
        {
            this.saveMinPages(this.minpages);
        }

        this.maxpages = this.getMaxPages();
        if (this.maxpages !== undefined)
        {
            this.saveMaxPages(this.maxpages);
        }

        this.color = this.getColor();
        if (this.color !== undefined)
        {
            this.saveColor(this.color);
        }

        this.max_count = this.getMaxCount();
        if (this.max_count !== undefined)
        {
            this.saveMaxCount(this.max_count);
        }

        this.props.callbacks.setStoreValue(report_type_name, REPORT_URL, report_url);

        this.state = {
            last_doc_only: this.max_count === undefined ? false : this.max_count === 1
          };
    }

    savePrinterId(printer_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, printer_id_name, printer_id);
    }

    getPrinterId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, printer_id_name, this.props.report.url);
    }

    saveUserId(user_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, user_id_name, user_id);
    }

    getUserId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, user_id_name, this.props.report.url);
    }

    saveGroupId(group_id)
    {
        this.props.callbacks.setStoreValue(report_type_name, group_id_name, group_id);
    }

    getGroupId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, group_id_name, this.props.report.url);
    }

    saveDocName(docname)
    {
        this.props.callbacks.setStoreValue(report_type_name, docname_name, docname);
    }

    getDocName()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, docname_name, this.props.report.url);
    }

    saveMinPages(value)
    {
        this.props.callbacks.setStoreValue(report_type_name, minpages_name, value);
    }

    getMinPages()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, minpages_name, this.props.report.url);
    }

    saveMaxPages(value)
    {
        this.props.callbacks.setStoreValue(report_type_name, maxpages_name, value);
    }

    getMaxPages()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, maxpages_name, this.props.report.url);
    }

    saveColor(value)
    {
        this.props.callbacks.setStoreValue(report_type_name, color_name, value);
    }

    getColor()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, color_name, this.props.report.url);
    }

    saveMaxCount(value)
    {
        this.props.callbacks.setStoreValue(report_type_name, max_count_name, value);
    }

    getMaxCount()
    {
        return getReportParam(this.props.callbacks.getStoreValue, report_type_name, max_count_name, this.props.report.url);
    }

    onSelectChangePrinter(selectedRowKeys) {
        this.printer_id = selectedRowKeys[0];
        this.savePrinterId(this.printer_id);
    }

    onSelectChangeUser(selectedRowKeys) {
        this.user_id = selectedRowKeys[0];
        this.saveUserId(this.user_id);
    }

    onSelectChangeUserGroup(selectedRowKeys) {
        this.group_id = selectedRowKeys[0];
        this.saveGroupId(this.group_id);
    }

    onDocNameChange(value) {
        this.saveDocName(value);
    }

    onMinPagesChange(value) {
        this.saveMinPages(value);
    }

    onMaxPagesChange(value) {
        this.saveMaxPages(value);
    }

    onSelectColor(value) {
        this.saveColor(value);

    }

    onLastOnly(checked) {
        this.setState({last_doc_only: checked});

        this.saveMaxCount(checked ? 1 : undefined);
    }

    render() {
    
        return (
            <div style={{align:"left", textAlign: "left"}}>
                <br/>
                <Form {... layout}
                    name="basic"
                    initialValues={{
                        'doc_name': this.docname,
                        'min_pages': this.minpages,
                        'max_pages': this.maxpages,
                        'color': this.color
                    }}                   
                >
                    <Form.Item 
                            label={this.props.intl.formatMessage({id: "IfDocNameContains"})}
                            name="doc_name" 
                    >
                        <Input style={{ width: 360 }} onChange={(e) => this.onDocNameChange(e.target.value)} />
                    </Form.Item>
                    <Form.Item 
                      label={this.props.intl.formatMessage({id: "IfMinPages"})}
                        name="min_pages" 
                        labelAlign="right"
                    >
                        <InputNumber min={0} max={999} 
                            style={{ width: 80 }} onChange={(e) => this.onMinPagesChange(e)} 
                        />
                    </Form.Item>
                    <Form.Item 
                      label={this.props.intl.formatMessage({id: "IfMaxPages"})}
                        name="max_pages" 
                        labelAlign="right"
                    >
                        <InputNumber min={0} max={999} 
                            style={{ width: 80 }} onChange={(e) => this.onMaxPagesChange(e)} 
                        />
                    </Form.Item>
                    <Form.Item 
                        label={this.props.intl.formatMessage({id: "IfDoc"})}
                        name="color" 
                        labelAlign="right"
                    >
                        <Radio.Group onChange={(e) => this.onSelectColor(e.target.value)} value={this.color}>
                            <Radio value={2}><FormattedMessage id="Color"/></Radio>
                            <Radio value={1}><FormattedMessage id="BlackWhite"/></Radio>
                            <Radio value={undefined}><FormattedMessage id="Any"/></Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item 
                        label={this.props.intl.formatMessage({id: "LastDocOnly"})}
                        name="last_doc" 
                        labelAlign="right"
                    >
                        <Checkbox checked={this.state.last_doc_only} onChange={(e) => this.onLastOnly(e.target.checked)}></Checkbox>
                    </Form.Item>
                    <Form.Item>
                    <PrintersSelectTable 
                        printer_id = {this.printer_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangePrinter(selectedRowKeys)}/>
                    </Form.Item>
                    <Form.Item>
                    <UsersSelectTable 
                        user_id = {this.user_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangeUser(selectedRowKeys)}/>
                    </Form.Item>
                    <Form.Item>
                    <UserGroupsSelectTable 
                        group_id = {this.group_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangeUserGroup(selectedRowKeys)}/>
                    </Form.Item>
                </Form>
                <ReportDescription description="Report.DocumentPrinted.Description"/>
            </div>
        );
      }
}

export default injectIntl(DocumentPrintedStep2, {
    withRef: true,
  });